(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8049],{

/***/ 71626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcement/nvidia-inception-program",
      function () {
        return __webpack_require__(67026);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/bolosign-nvidia-inception-program-header2.64bc27a9.webp","height":800,"width":2000,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAABwAQCdASoIAAMAAkA4JaRLgAALwAD++mZo/PelhDCJAx6HgVht+6igB5fGlAAA","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 35372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/bolosign-nvidia-inception-program.97eec9bb.webp","height":800,"width":2000,"blurDataURL":"data:image/webp;base64,UklGRjAAAABXRUJQVlA4ICQAAACQAQCdASoIAAMAAkA4JaQAApz9zgAA/v1Aj2w8XenL3eL8AAA=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15991);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);









const companyLogos = [
    {
        url: "9.png",
        name: "ABC Eyecare",
        haveCaseStudy: true,
        companyKey: "abc-eyecare".toLowerCase()
    },
    {
        url: "5.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "10.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "4.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "2.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "1.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "12.png",
        name: "Overstock Furniture",
        haveCaseStudy: true,
        companyKey: "overstock-furniture".toLowerCase()
    },
    {
        url: "11.png",
        name: "Lifestyle Design",
        haveCaseStudy: true,
        companyKey: "lifestyle-design".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "3.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    },
    {
        url: "8.png",
        name: "Benavest",
        haveCaseStudy: true,
        companyKey: "benavest".toLowerCase()
    }
];
const generateTestimonials = (companyKey)=>{
    let caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === companyKey);
    if (!caseStudy) {
        caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === "harry-corry-ltd");
    }
    const testimonial = {
        logo: caseStudy.companyLogo,
        company: caseStudy.name,
        quote: caseStudy.customerInsight.insight,
        name: caseStudy.customerInsight.by,
        title: caseStudy.customerInsight.authorPosition,
        avatar: caseStudy.customerInsight.image
    };
    return testimonial;
};
const AnimatedLogos = (param)=>{
    let { isInvert =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoveredKey, setHoveredKey] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoverPosition, setHoverPosition] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        x: 0,
        y: 0
    });
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    const handleMouseEnter = (param)=>{
        let { idx , companyKey , event  } = param;
        const rect = event.currentTarget.getBoundingClientRect();
        const marqueeRect = event.currentTarget.closest(".marquee-container").getBoundingClientRect();
        // Calculate position relative to the marquee container
        const x = rect.left - marqueeRect.left + rect.width / 2;
        const y = rect.top - marqueeRect.top;
        let formattedY = y - 280;
        if (companyKey === "angelfire") {
            formattedY = y - 320;
        } else if (companyKey === "mancosa") {
            formattedY = y - 380;
        } else if (companyKey === "beaver") {
            formattedY = y - 320;
        }
        setHoverPosition({
            x,
            y: formattedY
        });
        setHoveredIdx(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                pauseOnHover: true,
                children: companyLogos.map((logo, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]",
                        onClick: ()=>handleLogoClick(logo.companyKey),
                        onMouseEnter: (e)=>handleMouseEnter({
                                idx,
                                companyKey: logo.companyKey,
                                event: e
                            }),
                        onMouseLeave: ()=>setHoveredIdx(null),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/company/").concat(logo.url),
                                alt: logo.name,
                                className: "object-contain transition duration-300 group-hover:filter ".concat(isInvert ? "invert" : ""),
                                width: 120,
                                height: 120,
                                loading: "lazy"
                            })
                        })
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedLogos);


/***/ }),

/***/ 23660:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const CaseStudyHoverCard = (param)=>{
    let { logo , company , quote , name , title , avatar , className =""  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ".concat(styles.fadeScaleIn, " ").concat(className),
        style: {
            pointerEvents: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: company,
                            fill: true,
                            className: "object-contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold text-gray-900 text-base",
                        children: company
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("blockquote", {
                className: "text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic",
                children: quote
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-3 border-gray-100"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: avatar || "https://avatar.iran.liara.run/public/boy?username=".concat(name),
                            alt: name,
                            fill: true,
                            className: "object-cover"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-semibold text-gray-900 text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-gray-500 text-[10px] mt-0.5",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CaseStudyHoverCard)));


/***/ }),

/***/ 43155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89583);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15991);
/* harmony import */ var react_icons_gr__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45155);
/* harmony import */ var _AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7434);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);












const companyLogos = [
    {
        url: "1.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "2.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "3.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "4.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "5.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "8.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    }
];
const CustomersComponent = ()=>{
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: " mx-auto px-4 sm:px-6 lg:px-8 py-2 w-full text-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center mb-8 ",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-lg font-semibold tracking-wide uppercase mb-2",
                        children: "Trusted by Leading Brands Across Healthcare, Education, Retail, and Logistics"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-center justify-center gap-4 mb-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/case-studies/capterra-logo.png"),
                                        alt: "Capterra Logo",
                                        width: 20,
                                        height: 20,
                                        className: "rounded-full"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex items-center ",
                                        children: [
                                            ...Array(5)
                                        ].map((_, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_8__/* .FaStar */ .QJe, {
                                                className: "text-yellow-400 text-sm"
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-medium ml-1",
                                        children: "4.9 rating"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_gr__WEBPACK_IMPORTED_MODULE_9__/* .GrGroup */ .ZMl, {
                                        className: "text-xl "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "font-medium",
                                        children: "50k+ businesses"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AnimatedLogos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomersComponent);


/***/ }),

/***/ 67026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56475);
/* harmony import */ var components_customers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43155);
/* harmony import */ var components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7434);









const NvidiaInceptionProgram = ()=>{
    const schema = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: "BoloSign Joins the NVIDIA Inception Program",
        description: "A huge step forward for our team, our mission, and the future of AI-powered eSignatures.",
        author: {
            "@type": "Organization",
            name: "BoloSign"
        },
        publisher: {
            "@type": "Organization",
            name: "BoloSign",
            logo: {
                "@type": "ImageObject",
                url: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
            }
        },
        datePublished: "2025-08-21",
        dateModified: "2025-08-21",
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "https://www.bolosign.com/announcement/nvidia-inception-program/"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "BoloSign Joins the NVIDIA Inception Program | Official Announcement"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "A huge step forward for our team, our mission, and the future of AI-powered eSignatures. BoloSign has been accepted into the NVIDIA Inception Program."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/announcement/nvidia-inception-program/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign Joins the NVIDIA Inception Program"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "A huge step forward for our team, our mission, and the future of AI-powered eSignatures."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/announcement/nvidia-inception-program/"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/announcements/bolosign-nvidia-inception-program.webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign Joins the NVIDIA Inception Program"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "A huge step forward for our team, our mission, and the future of AI-powered eSignatures."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/announcements/bolosign-nvidia-inception-program.webp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(schema)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-4xl mx-auto px-4 pt-12 md:pt-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-center mb-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "max-w-xl mx-auto text-4xl md:text-5xl font-bold text-gray-900 mb-6",
                                children: "BoloSign Joins the NVIDIA Inception Program"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-3xl md:text-4xl font-bold text-gray-900 mb-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-xl text-gray-600 max-w-3xl mx-auto",
                                children: "A huge step forward for our team, our mission, and the future of AI-powered eSignatures."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: __webpack_require__(35372),
                            alt: "BoloSign Joins NVIDIA Inception Program",
                            width: 1200,
                            height: 600,
                            className: "w-full h-auto rounded-lg border"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "prose prose-lg max-w-none",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: "The Mission That Guided Us"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-6",
                                children: "From day one, BoloSign wasn't built to be another fancy product… it was built to solve a problem."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-6",
                                children: "We saw an opportunity to redefine how organizations whether startups, agencies, legal teams, or enterprises get documents signed. We focused on clarity, fairness (flat pricing, no hidden fees), reliability, and thoughtful design."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-8",
                                children: "That foundational purpose has brought thousands of diverse teams to our platform. And now, our next chapter begins."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: [
                                    "We're officially part of the",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "NVIDIA Inception Program"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-gray-700 mb-6",
                                children: [
                                    "We're proud to share that",
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        children: "BoloSign has been accepted into the NVIDIA Inception Program"
                                    }),
                                    ", a global initiative that backs forward-thinking companies defining the future of AI innovation."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-8",
                                children: "This isn't a check-the-box program. It's access to deep technical resources, strategic mentorship, and early-stage AI frameworks. It spells credibility. It means NVIDIA not just as a name, but as a partner is in our corner."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: "The Power of Partnership"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-6",
                                children: "The NVIDIA Inception Program gives BoloSign exclusive access to industry-leading technology and expertise. We're talking about the latest advancements in GPU computing, scalable AI infrastructure, and collaborative opportunities with visionary companies shaping tomorrow."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-4",
                                children: "With NVIDIA's backing, BoloSign is positioned to:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-disc pl-6 mb-8 text-gray-700 space-y-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Leverage world-class AI acceleration for digital agreements, security checks, and data analytics."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Innovate rapidly, adopting the latest tools and frameworks for unmatched reliability and speed."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        children: "Collaborate with leading startups and industry experts, unlocking insights, best practices, and new go-to-market strategies."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-8",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    src: __webpack_require__(68159),
                                    alt: "BoloSign Joins NVIDIA Inception Program",
                                    width: 1200,
                                    height: 600,
                                    className: "w-full h-auto rounded-lg border"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: "What BoloSign Customers Can Expect"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-4",
                                children: "Our collaboration with NVIDIA isn't just a badge it's a promise to deliver more:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: "list-disc pl-6 mb-8 text-gray-700 space-y-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "Smarter, Faster Agreements:"
                                            }),
                                            " Harnessing advanced AI and cloud resources, BoloSign will deliver even faster, smarter eSignature workflows, improving efficiency at scale."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "Enterprise-Grade Security:"
                                            }),
                                            " Enhanced compliance features powered by NVIDIA testing and support."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                children: "Cutting-Edge Innovation:"
                                            }),
                                            " Early access to new technologies and methodologies, so our users reap the rewards before the competition."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-2xl font-bold text-gray-900 mb-4",
                                children: "A Journey That Benefits All"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-6",
                                children: "From small startups closing their first major deal to global enterprises automating thousands of contracts, BoloSign's journey with NVIDIA Inception is about championing every business trying to move faster, smarter, and more securely. Our story is driven by our users—their growth, challenges, and the future they build."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-8",
                                children: "Our engineers, product managers, and customer success teams are already collaborating with NVIDIA experts to integrate next-gen features and create more value for BoloSign users. This landmark partnership is not the finish line, it's the launchpad for a new era of digital agreements."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-xl font-bold text-gray-900 mb-4",
                                children: "Invitation to Join Us"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-8",
                                children: "If you're already a user, thanks for believing in us early. If you're just browsing know this… BoloSign now carries vote of confidence from one of the world's most respected names in AI, and we're just getting started."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    background: "linear-gradient(275deg, #c86aff -8.37%, #3164ff)"
                                },
                                className: "rounded-2xl p-8 mb-8 text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-2xl font-bold text-white mb-4",
                                        children: "Ready to see what smarter signing feels like?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-gray-50 mb-6 max-w-2xl mx-auto",
                                        children: "Experience the future of document signing with BoloSign, now enhanced by NVIDIA's cutting-edge AI technology."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-center flex items-center gap-4 flex-wrap justify-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/clm/request-demo",
                                            className: "inline-block px-6 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-purple-50 hover:text-blue-600 transition-colors",
                                            children: "Request a Demo"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-xl font-bold text-gray-900 mb-4",
                                children: "Closing Thought"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-4",
                                children: "Some companies chase funding. Some chase features. We chose trust."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-4",
                                children: "Joining NVIDIA Inception doesn't change who we are it accelerates everything we can become."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 mb-6",
                                children: "Let's sign smarter."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-gray-700 font-semibold",
                                children: "— Team BoloSign"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full pt-10 sm:pb-8 sm:pt-16 bg-dark mt-12 lg:mt-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-screen-xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-3xl md:text-4xl leading-snug text-center mb-3 text-white font-semibold",
                            children: [
                                "5,000+ Companies ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " Use BoloForms Around the World"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (NvidiaInceptionProgram);


/***/ }),

/***/ 97005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6158,5991,9774,2888,179], function() { return __webpack_exec__(71626); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);